const readPedido = ({setPedidoAtual, setTotalAtual}) => {
  const request = indexedDB.open("meusPedidos", 3)
  request.onsuccess = function(event) {
    const db = request.result
    const transaction = db.transaction(["pedidos"])
    const objectStore = transaction.objectStore("pedidos")
    // const req = objectStore.get(idForSearch)
    const reqAll = objectStore.getAll()
    reqAll.onsuccess = function(event) {
      const resultPedidos = reqAll.result
      // console.log('resultPedidos ', resultPedidos);
      const pedidos = resultPedidos.reverse()//Ordenando pela última venda
      setPedidoAtual(pedidos)
      let joinSubtotal = []
      for (var i = 0; i < pedidos.length; i++) {
        let newArray = Number(pedidos[i].subtotal)
        joinSubtotal.push(newArray)
        const totalPedido = joinSubtotal.reduce((a,b) => a + b)
        setTotalAtual(totalPedido)
      }
    }
  }
}
export default { readPedido }
